/* global __BUILD_RELEASE__ */

/**
 * Build/runtime identity attached to every error report so the Monitoring page
 * can tell WHICH app, environment and build an error came from.
 *
 * `__BUILD_RELEASE__` is injected by vite.config.js `define` at build time from
 * the CI-provided GIT_COMMIT, with a safe "unknown" fallback. The `typeof`
 * guard means a missing define can never throw a ReferenceError in dev.
 */
export const APP = "rc"; // app.retail-circle.io

export const APP_ENV =
  import.meta.env.VITE_APP_ENV ||
  import.meta.env.VITE_API_ENV ||
  "unknown";

export const APP_RELEASE =
  (typeof __BUILD_RELEASE__ !== "undefined" && __BUILD_RELEASE__) ||
  import.meta.env.VITE_APP_RELEASE ||
  "unknown";
